function carousel() {
    var home_elem = document.querySelector('.home_cover .wp-block-group__inner-container .wp-block-group__inner-container'),
        product_gallery_elem = document.querySelector('.single-product .gallery_carousel .main'),
        product_gallery_elem_nav = document.querySelector('.single-product .gallery_carousel nav');

    if( home_elem ) {
        if( ! document.querySelector('.flickity-viewport') ) {
            var flkty = new Flickity( home_elem, {
                wrapAround: true,
                prevNextButtons: false,
                autoPlay: 6000
            });
        }
    }

    if( product_gallery_elem ) {

        document.querySelectorAll('.single-product .gallery > figure, .gallery_carousel .close').forEach( element => {
            element.addEventListener('click', (event) => {
                document.body.classList.toggle('gallery_open');
                
                if( document.querySelectorAll('.single-product .gallery_carousel .main figure').length > 1 ) {

                    var flkty_gallery = new Flickity( product_gallery_elem, {
                        contain: true,
                        // wrapAround: true,
                        imagesLoaded: true,
                        pageDots: false,
                        prevNextButtons: false,
                        // sync: product_gallery_elem_nav
                    });
        
                    var flkty_gallery_nav = new Flickity( product_gallery_elem_nav, {
                        contain: true,
                        imagesLoaded: true,
                        asNavFor: product_gallery_elem,
                        pageDots: false,
                        prevNextButtons: false,
                    });
                
                } else {
                    document.querySelector('.single-product .gallery_carousel .main').classList.add('solo');
                }
            });
        });
        
    }
    
}

carousel();